import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const ConfirmationContent = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px"
}));

export const ConfirmationItem = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "12px 0",
  borderBottom: `1px solid ${theme.palette.divider}`,
  "&:last-child": {
    borderBottom: "none"
  }
}));

export const ConfirmationLabel = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  color: theme.palette.text.secondary,
  fontSize: "14px",
  fontWeight: 500,
  minWidth: "200px"
}));

export const ConfirmationValue = styled(Box)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: "14px",
  fontWeight: 400,
  textAlign: "right",
  flex: 1
}));

export const SystemMileageBadge = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  backgroundColor: theme.palette.primary.light,
  color: theme.palette.primary.main,
  padding: "6px 12px",
  borderRadius: "20px",
  fontSize: "14px",
  fontWeight: 500
}));
